import { classNames, styleString, type VNode, type VProps } from "@broadpaper/core";

const SVG_NS = "http://www.w3.org/2000/svg";

/** Creates a DOM node from a VNode. Attribute values are set with setAttribute (never innerHTML). */
export function vnodeToDom(v: VNode | string, doc: Document = document): Node {
  if (typeof v === "string") return doc.createTextNode(v);
  const el = v.ns === "svg" ? doc.createElementNS(SVG_NS, v.tag) : doc.createElement(v.tag);
  applyProps(el, v.props);
  for (const c of v.children) el.appendChild(vnodeToDom(c, doc));
  return el;
}

function applyProps(el: Element, props: VProps) {
  for (const [k, v] of Object.entries(props)) {
    if (v === undefined || v === null || v === false) continue;
    if (k === "class") {
      const c = classNames(v as VProps["class"]);
      if (c) el.setAttribute("class", c);
    } else if (k === "style") {
      const s = styleString(v as VProps["style"]);
      if (s) el.setAttribute("style", s);
    } else if (v === true) el.setAttribute(k, "");
    else el.setAttribute(k, String(v));
  }
}

/** Replaces the children of `container` with the given VNodes. */
export function mountVNodes(container: HTMLElement, vnodes: Array<VNode | string>): void {
  const doc = container.ownerDocument;
  const frag = doc.createDocumentFragment();
  for (const v of vnodes) frag.appendChild(vnodeToDom(v, doc));
  container.replaceChildren(frag);
}

/** Injects (or updates) a style element with the given id. */
export function ensureStyle(doc: Document, id: string, css: string): HTMLStyleElement {
  let el = doc.getElementById(id) as HTMLStyleElement | null;
  if (!el) {
    el = doc.createElement("style");
    el.id = id;
    doc.head.appendChild(el);
  }
  if (el.textContent !== css) el.textContent = css;
  return el;
}
